import BenchmarkDetail from "../types/ProjectGoal/BenchmarkDetail";
import http from "../http-common";
import ProjectGoalDetail, { ProjectGoalDetailUpdate }  from "../types/ProjectGoal/ProjectGoalDetail";

class ProjectGoalService {
    getBenchmarkDetails(projectID: string) {
        return http.get<BenchmarkDetail>(`/getBenchmarkDetails?projectID=${projectID}`);
    }

    getProjectGoalDetails(projectID: string) {
        return http.get<ProjectGoalDetail>(`/getProjectGoalDetails?projectID=${projectID}`);
    }

    updateProjectGoalDetails(projectGoalDetail: ProjectGoalDetail, userEmail: string) {
        const projectGoalDetailUpdate: ProjectGoalDetailUpdate = {
            projectGoalDetail,
            userEmail,
        };
        return http.post('/updateProjectGoalDetails', projectGoalDetailUpdate, { headers: { 'Content-Type': 'application/json' }});
    }
}

const projectGoalServiceInstance = new ProjectGoalService();

export default projectGoalServiceInstance;